export const UNIT_PLAN_PAGE_DESCRIPTION = 'International Baccalaureate Format Unit Plan';